
  import { LogHelper } from "@/common/LogHelper";
import {Component, Prop, Vue} from "vue-property-decorator";
  // import el from "element-ui/src/locale/lang/el";

  @Component({
    name: "RankingList",
    components: {},
    props: [
      "wholeTopEfficiency",
      "avgEfficiency",
      "avgEfficiencyRank",
      "lastHourAvgEfficiency"
    ],
    watch: {
      wholeTopEfficiency: {
        handler(newone, oldone) {
          this.showData.wholeTopEfficiency = newone;
        }
      },
      avgEfficiency: {
        handler(newone, oldone) {
          this.showData.avgEfficiency = newone;
        }
      },
      avgEfficiencyRank: {
        handler(newone, oldone) {
          this.showData.avgEfficiencyRank = newone;
        }
      },
      lastHourAvgEfficiency: {
        handler(newone, oldone) {
          this.showData.lastHourAvgEfficiency = newone;
        }
      }
    }
  })
  export default class extends Vue {
    public fieldValue = 1500;
    public showData = {
      avgEfficiency: "0",
      lastHourAvgEfficiency: "0",
      avgEfficiencyRank: "0",
      frequencyRank: "0",
      wholeTopEfficiency: "0"
    };

    mounted() {
      /// ###########
      /// 方法一(通过对应的操作core进行交互，采用通用common)逐渐弃用
      /// 使用方法二替代(直接与通用的条码微视排行榜的obj_RankingList_Core进行交互)
      /// #########

      ///方法一
      // try {
      //   obj_Common.register_getfieldvalue(this.updatefieldValue);
      // } catch (error) {
      //   LogHelper.Error(
      //     "[错误]:注册个人操作排行榜数据的回调函数执行失败(旧):" + error
      //   );
      // }
      // ///

      ///方法二
      try {
        if (typeof obj_RankingList_Core !== "undefined") {
          obj_RankingList_Core.registerJavaScriptCallback(
            "RankingListRefreshState",
            value => {
              this.showData.avgEfficiency = value.avgEfficiency;
              this.showData.lastHourAvgEfficiency = value.lastHourAvgEfficiency;
              this.showData.avgEfficiencyRank = value.avgEfficiencyRank;
              this.showData.frequencyRank = value.frequencyRank;
              this.showData.wholeTopEfficiency = value.wholeTopEfficiency;
            }
          );
          obj_RankingList_Core.registerJavaScriptCallback(
            "RankingListRefreshFieldValue",
            value => {
              this.fieldValue = value;
            }
          );
        }
      } catch (error) {
        LogHelper.Error(
          "[错误]:注册个人操作排行榜数据的回调函数执行失败(新):" + error
        );
      }
      ///
    }

    public updatefieldValue(value) {
      this.fieldValue = value;
    }
  }
